









import Vue, { PropType } from 'vue';
import { i18n, i18nHints } from '../../plugins/i18n';
import SectionItemForm, {
  FormDataInterface,
} from '@/containers/cv-section-gallery-item/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionGalleryItemStoreNew from '@/store/modules/cvSectionGalleryItemNew';
import { CvSectionGallery } from '@/../gen';

export default Vue.extend({
  components: {
    SectionItemForm,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    section: {
      type: Object as PropType<CvSectionGallery>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title, image, description, _url }: FormDataInterface) {
      try {
        await this.$store.dispatch(
          CvSectionGalleryItemStoreNew.CreateCvSectionGalleryItem.namespaced({
            params: {
              cv_id: this.cvId,
              cv_section_gallery_id: this.section.id,
            },
            // FIXME avoid using any
            body: { title, image: image as any, description, _url },
          })
        );
        this.$notifySuccess(i18n.tc(i18nHints.common.notification.created));
        // refresh sections
        this.$store.dispatch(
          CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
        );
        this.$router.push({ name: 'cv_edit_path' });
      } catch {
        this.$notifyError(
          i18n.tc(i18nHints.common.notification.check_input_validation_error)
        );
      }
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
  },
});
